export default __webpack_public_path__ + "static/data-glider-logo-069da0c251be1975c21d622fd0ac54f6.png";